module.exports = __webpack_public_path__ + "img/2.774aa0e0.jpg";